import { FC } from 'react';

import { useConfigSlice } from '../../../store/slices/config/selectors';
import { L12nText } from '../../text/L12nText';

import { NickNameEditFormConnected } from './NickNameEditFormConnected';
import { NickNameEditFooterMessageConnected } from './NickNameFooterMessageConnected';

import styles from './nickNameSettingsMobileEdit.module.css';

export const NickNameSettingsMobileEditConnected: FC = () => {
  const playerName = useConfigSlice.playerConfig()?.screenName;

  return (
    <div>
      <div className={styles.nickName_settings_label}>{<L12nText tk="SETTINGS_NICKNAME" />}:</div>
      <NickNameEditFormConnected nickName={playerName ?? ''} />
      <NickNameEditFooterMessageConnected isMobileEdit={true} />
    </div>
  );
};
